// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.olr-modal-content-left {
  text-align: left;
  line-height: 1em;
  padding-bottom: 40px;
}

.olr-modal-edit-spacing {
  margin-top: 40px;
}

.olr-modal-content-padding {
  padding: 32px 24px;
}

.modal-padding-fix {
  padding-bottom: 0;
}

.modal-height-fix {
  height: 0px !important;
  padding-bottom: 10%;
}

.olr-modal {
  display: none;
  align-content: center;
}

.olr-pnf-modal-line-spacing {
  margin-top: 49px;
  margin-bottom: 78px;
}

.-oneX-btn-fit-content {
  margin: auto;
}

.modal-size {
  width: 26rem !important;
  height: 26rem !important;
}

.modal-align-text {
  margin-left: 16%;
  margin-right: 16%;
  width: -moz-fit-content;
  width: fit-content;
}

.padding-right-0 {
  padding-right: 0px;
}

ul li::before {
  content: "\\2022";
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  color: #D62311;
}

.filing-text{
  color: #D62311;
  margin-top: 4%;
}

.lr-go-back, .lr-go-forward {
  color: #D62311;
}

.lr-go-back-disabled, .lr-go-forward-disabled {
  color: gray;
}


.header {
  width: 100%;
  max-width: 730px;
  height: 75px;
  margin-bottom: 53px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
.oneX-header {
  margin-bottom: 53px;
}
.header-nav {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
}
.lr-nav-btn {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  color: #6e6e6e;
}
.lr-nav-btn-disabled {
background: none;
border: none;
display: flex;
align-items: center;
color: #6e6e6e;
opacity: 0.4;
}
.lr-progress-btn {
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: -16px;
  color: #6e6e6e;
  font-weight: 600;
  line-height: 21px;
  font-size: 14px;
}
.lr-progress-btn-sub {
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
}
.lr-progress-chev {
  align-self: center;
  margin-left: 6px;
  width: 13px;
  height: 13px;
}

@media(min-width: 768px) {
  .header {
      margin-bottom: 62px;
      height: 96px;
  }
  .oneX-header {
      margin-bottom: 62px;
  }
  .lr-progress-btn {
      font-size: 16px;
      line-height: 24px;
      font-weight: normal;
  }
  .lr-back-icon {
      padding-right: 8px;
  }
  .lr-forward-icon {
    padding-left: 8px;
}
.lr-forward-icon-disabled {
  padding-left: 8px;
  opacity: 0.4;
}
.lr-back-icon-disabled {
  padding-right: 8px;
  opacity: 0.4;
}
}

.lr-nav-btn-dimensions {
  width: 24px;
  height: 16px;
}

/* Deductable example grid */
.deductible-grid-title {
  background-color: #403c3c;
  color: #fff;
  display: inline-block;
  padding: 4px 8px;
}

.deductible-grid {
  background-color: #f7f0e4;
  display: grid;
  grid-column-gap: 8px;
  grid-row-gap: 4px;
  grid-template-areas:
    "title1  .        title2     .   title3"
    "damages subtract youpay     sum sfpays"
    ".       .        deductible .   .";
  grid-template-columns: repeat(5, auto);
  grid-template-rows: repeat(3, auto);
  margin-bottom: 15px;
  padding: 16px 24px;
  width: -moz-fit-content;
  width: fit-content;
}

.grid-title-1 {
  align-items: center;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  grid-area: title1;
  justify-content: center;
}

.grid-title-2 {
  align-items: center;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  grid-area: title2;
  justify-content: center;
}

.grid-title-3 {
  align-items: center;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  grid-area: title3;
  justify-content: center;
}

.grid-damages {
  align-items: self-start;
  display: flex;
  flex-direction: row;
  font-size: 22px;
  font-weight: 500;
  grid-area: damages;
  justify-content: center;
  text-decoration: none;
}

.grid-operator-subtract {
  align-items: self-start;
  display: flex;
  flex-direction: row;
  font-size: 22px;
  font-weight: 500;
  grid-area: subtract;
  justify-content: center;
  text-decoration: none;
}

.grid-youpay {
  align-items: self-start;
  display: flex;
  flex-direction: row;
  font-size: 22px;
  font-weight: 500;
  grid-area: youpay;
  justify-content: center;
  text-decoration: none;
}

.grid-operator-sum {
  align-items: self-start;
  display: flex;
  flex-direction: row;
  font-size: 22px;
  font-weight: 500;
  grid-area: sum;
  justify-content: center;
  text-decoration: none;
}

.grid-sfpays {
  align-items: self-start;
  display: flex;
  flex-direction: row;
  font-size: 22px;
  font-weight: 500;
  grid-area: sfpays;
  justify-content: center;
  text-decoration: none;
}

.grid-deductible {
  align-items: self-start;
  display: grid;
  font-size: 12px;
  font-weight: 400;
  grid-area: deductible;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/drawer-deductible-overview/drawer-deductible-overview.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;AACA,gBAAgB;AAChB,YAAY;AACZ,aAAa;AACb,mBAAmB;AACnB,cAAc;AACd,YAAY;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;MACI,mBAAmB;MACnB,YAAY;EAChB;EACA;MACI,mBAAmB;EACvB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,mBAAmB;EACvB;EACA;MACI,kBAAkB;EACtB;EACA;IACE,iBAAiB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB;;;uCAGqC;EACrC,sCAAsC;EACtC,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":[".olr-modal-content-left {\n  text-align: left;\n  line-height: 1em;\n  padding-bottom: 40px;\n}\n\n.olr-modal-edit-spacing {\n  margin-top: 40px;\n}\n\n.olr-modal-content-padding {\n  padding: 32px 24px;\n}\n\n.modal-padding-fix {\n  padding-bottom: 0;\n}\n\n.modal-height-fix {\n  height: 0px !important;\n  padding-bottom: 10%;\n}\n\n.olr-modal {\n  display: none;\n  align-content: center;\n}\n\n.olr-pnf-modal-line-spacing {\n  margin-top: 49px;\n  margin-bottom: 78px;\n}\n\n.-oneX-btn-fit-content {\n  margin: auto;\n}\n\n.modal-size {\n  width: 26rem !important;\n  height: 26rem !important;\n}\n\n.modal-align-text {\n  margin-left: 16%;\n  margin-right: 16%;\n  width: fit-content;\n}\n\n.padding-right-0 {\n  padding-right: 0px;\n}\n\nul li::before {\n  content: \"\\2022\";\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n  margin-left: -1em;\n  color: #D62311;\n}\n\n.filing-text{\n  color: #D62311;\n  margin-top: 4%;\n}\n\n.lr-go-back, .lr-go-forward {\n  color: #D62311;\n}\n\n.lr-go-back-disabled, .lr-go-forward-disabled {\n  color: gray;\n}\n\n\n.header {\n  width: 100%;\n  max-width: 730px;\n  height: 75px;\n  margin-bottom: 53px;\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n}\n.oneX-header {\n  margin-bottom: 53px;\n}\n.header-nav {\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n  align-items: center;\n}\n.lr-nav-btn {\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  color: #6e6e6e;\n}\n.lr-nav-btn-disabled {\nbackground: none;\nborder: none;\ndisplay: flex;\nalign-items: center;\ncolor: #6e6e6e;\nopacity: 0.4;\n}\n.lr-progress-btn {\n  background: none;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: -16px;\n  color: #6e6e6e;\n  font-weight: 600;\n  line-height: 21px;\n  font-size: 14px;\n}\n.lr-progress-btn-sub {\n  color: #6e6e6e;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 18px;\n}\n.lr-progress-chev {\n  align-self: center;\n  margin-left: 6px;\n  width: 13px;\n  height: 13px;\n}\n\n@media(min-width: 768px) {\n  .header {\n      margin-bottom: 62px;\n      height: 96px;\n  }\n  .oneX-header {\n      margin-bottom: 62px;\n  }\n  .lr-progress-btn {\n      font-size: 16px;\n      line-height: 24px;\n      font-weight: normal;\n  }\n  .lr-back-icon {\n      padding-right: 8px;\n  }\n  .lr-forward-icon {\n    padding-left: 8px;\n}\n.lr-forward-icon-disabled {\n  padding-left: 8px;\n  opacity: 0.4;\n}\n.lr-back-icon-disabled {\n  padding-right: 8px;\n  opacity: 0.4;\n}\n}\n\n.lr-nav-btn-dimensions {\n  width: 24px;\n  height: 16px;\n}\n\n/* Deductable example grid */\n.deductible-grid-title {\n  background-color: #403c3c;\n  color: #fff;\n  display: inline-block;\n  padding: 4px 8px;\n}\n\n.deductible-grid {\n  background-color: #f7f0e4;\n  display: grid;\n  grid-column-gap: 8px;\n  grid-row-gap: 4px;\n  grid-template-areas:\n    \"title1  .        title2     .   title3\"\n    \"damages subtract youpay     sum sfpays\"\n    \".       .        deductible .   .\";\n  grid-template-columns: repeat(5, auto);\n  grid-template-rows: repeat(3, auto);\n  margin-bottom: 15px;\n  padding: 16px 24px;\n  width: fit-content;\n}\n\n.grid-title-1 {\n  align-items: center;\n  display: flex;\n  font-size: 12px;\n  font-weight: 400;\n  grid-area: title1;\n  justify-content: center;\n}\n\n.grid-title-2 {\n  align-items: center;\n  display: flex;\n  font-size: 12px;\n  font-weight: 400;\n  grid-area: title2;\n  justify-content: center;\n}\n\n.grid-title-3 {\n  align-items: center;\n  display: flex;\n  font-size: 12px;\n  font-weight: 400;\n  grid-area: title3;\n  justify-content: center;\n}\n\n.grid-damages {\n  align-items: self-start;\n  display: flex;\n  flex-direction: row;\n  font-size: 22px;\n  font-weight: 500;\n  grid-area: damages;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.grid-operator-subtract {\n  align-items: self-start;\n  display: flex;\n  flex-direction: row;\n  font-size: 22px;\n  font-weight: 500;\n  grid-area: subtract;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.grid-youpay {\n  align-items: self-start;\n  display: flex;\n  flex-direction: row;\n  font-size: 22px;\n  font-weight: 500;\n  grid-area: youpay;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.grid-operator-sum {\n  align-items: self-start;\n  display: flex;\n  flex-direction: row;\n  font-size: 22px;\n  font-weight: 500;\n  grid-area: sum;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.grid-sfpays {\n  align-items: self-start;\n  display: flex;\n  flex-direction: row;\n  font-size: 22px;\n  font-weight: 500;\n  grid-area: sfpays;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.grid-deductible {\n  align-items: self-start;\n  display: grid;\n  font-size: 12px;\n  font-weight: 400;\n  grid-area: deductible;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
